import React, { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import api, { formatPrice } from "../lib/api";
import { Link } from "react-router-dom";

export default function Reports() {
  const [kpi, setKpi] = useState(null);
  const [waivers, setWaivers] = useState([]);
  const [funnel, setFunnel] = useState(null);

  useEffect(() => {
    api.get("/reports/kpi").then(({ data }) => setKpi(data));
    api.get("/reports/waivers").then(({ data }) => setWaivers(data));
    api.get("/reports/booking-funnel").then(({ data }) => setFunnel(data));
  }, []);

  return (
    <AdminLayout>
      <div className="mb-6">
        <p className="font-mono text-xs uppercase tracking-[0.18em] text-sage mb-2">— Reports</p>
        <h1 className="font-display text-4xl text-charcoal">Operational reports</h1>
      </div>

      <div className="grid lg:grid-cols-3 gap-6 mb-6">
        <div className="bg-white border border-hairline rounded-lg shadow-warm p-6">
          <p className="font-ui font-semibold text-charcoal mb-4">KPIs · Today</p>
          {kpi && (
            <dl className="grid grid-cols-2 gap-4 text-sm font-ui">
              <div><dt className="text-slate text-xs">Appointments</dt><dd className="text-charcoal font-medium">{kpi.appointments_today}</dd></div>
              <div><dt className="text-slate text-xs">Completed</dt><dd className="text-charcoal font-medium">{kpi.completed}</dd></div>
              <div><dt className="text-slate text-xs">Revenue</dt><dd className="text-charcoal font-medium">{formatPrice(kpi.todays_revenue)}</dd></div>
              <div><dt className="text-slate text-xs">Active packages</dt><dd className="text-charcoal font-medium">{kpi.active_packages}</dd></div>
            </dl>
          )}
        </div>
        <div className="bg-white border border-hairline rounded-lg shadow-warm p-6">
          <p className="font-ui font-semibold text-charcoal mb-4">Booking funnel</p>
          {funnel && (
            <dl className="grid grid-cols-3 gap-4 text-sm font-ui">
              <div><dt className="text-slate text-xs">Held</dt><dd className="text-charcoal font-medium">{funnel.held}</dd></div>
              <div><dt className="text-slate text-xs">Confirmed</dt><dd className="text-charcoal font-medium">{funnel.confirmed}</dd></div>
              <div><dt className="text-slate text-xs">Expired</dt><dd className="text-charcoal font-medium">{funnel.canceled_hold}</dd></div>
            </dl>
          )}
        </div>
        <div className="bg-white border border-hairline rounded-lg shadow-warm p-6" data-testid="waivers-report">
          <p className="font-ui font-semibold text-charcoal mb-2">Missing or expired waivers</p>
          <p className="text-3xl font-ui font-semibold text-forest">{waivers.length}</p>
          <p className="text-xs font-ui text-slate mt-2">Clients that need attention before their next visit.</p>
        </div>
      </div>

      <div className="bg-white border border-hairline rounded-lg shadow-warm">
        <div className="px-6 py-4 border-b border-hairline">
          <h2 className="font-ui font-semibold text-charcoal">Waivers report</h2>
        </div>
        <ul className="divide-y divide-hairline">
          {waivers.length === 0 && <li className="px-6 py-12 text-center text-sm font-ui text-slate">All clients have current waivers.</li>}
          {waivers.map((w) => (
            <li key={w.client.id} className="px-6 py-3 flex items-center justify-between text-sm font-ui">
              <Link to={`/admin/clients/${w.client.id}`} className="text-charcoal hover:text-forest">
                {w.client.first_name} {w.client.last_initial}.
              </Link>
              <span className={`px-2 py-1 rounded-pill text-xs ${w.status === "missing" ? "bg-status-warning-bg text-status-warning" : "bg-status-danger-bg text-status-danger"}`}>{w.status}</span>
            </li>
          ))}
        </ul>
      </div>
    </AdminLayout>
  );
}
